import * as React from 'react'

import { useLmfAnalyticsContext } from '@syconium/little-miss-figgy'

import { EmbroideryFont } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { useRestrictedEmbroideryFonts } from '../../../../../../containers/EmbroideryContainer/utils/isEmbroideryColorAllowedForProduct'
import { FontSelector } from '../../../primitives/selectors/FontSelector/FontSelector'

export type TextFontPickerProps = {
  selectedFontKey: EmbroideryFont['key'] | undefined
  onSelectFont(font: EmbroideryFont): void
  errorMessage?: string
  disabled?: boolean
}

export const TextFontPicker: React.FC<TextFontPickerProps> = ({
  selectedFontKey,
  onSelectFont,
  errorMessage,
  disabled,
}) => {
  // Temporary unblocking of fonts for DTC. Remove this in LFE-188
  const fonts = useRestrictedEmbroideryFonts([])
  const labelId = React.useId()
  const { track, getContextChain } = useLmfAnalyticsContext()

  const selectFont = (font: EmbroideryFont) => {
    track({
      action: 'click',
      element: 'button',
      variant: 'font',
      label: font.key,
      context: getContextChain(),
      href: undefined,
    })
    onSelectFont(font)
  }

  return (
    <FontSelector
      disabled={disabled}
      errorMessage={errorMessage}
      fonts={fonts}
      labelId={labelId}
      onSelectFont={selectFont}
      outlineWhenSelected
      selectedFontKey={selectedFontKey}
    />
  )
}
